import React from "react";
import { motion } from "framer-motion";

export default function Reframe() {
  return (
    <section id="reframe" className="relative py-24 md:py-32 px-6 md:px-10 border-t border-white/5" data-testid="reframe-section">
      <div className="max-w-7xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
        >
          <p className="font-mono text-xs tracking-[0.3em] uppercase text-primary-c mb-4">The Reframe</p>
          <h2 className="font-serif text-4xl md:text-6xl tracking-tight max-w-4xl leading-[1.05]">
            It looks like a drum circle. <span className="italic text-fg/50">It's grounded brain science.</span>
          </h2>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-px bg-white/10 mt-16 shape-r overflow-hidden">
          <div className="bg-bg p-10 md:p-14" data-testid="reframe-assumption">
            <p className="font-mono text-[11px] tracking-[0.25em] uppercase text-fg/40 mb-6">The Assumption</p>
            <h3 className="font-serif text-2xl md:text-3xl text-fg/70 mb-5">Just a Drum Circle</h3>
            <p className="text-fg/50 leading-relaxed md:text-lg">
              Casual, unstructured entertainment. A hobbyist approach focused purely on recreation for the masses — feel-good noise with no clinical intent or measured outcome.
            </p>
          </div>
          <div className="bg-bg p-10 md:p-14 relative" data-testid="reframe-reality">
            <div className="absolute inset-0 opacity-40" style={{ background: "radial-gradient(80% 100% at 100% 0%, rgba(var(--glow),0.14), transparent 60%)" }} />
            <div className="relative">
              <p className="font-mono text-[11px] tracking-[0.25em] uppercase text-primary-c mb-6">The AvenueSpeak Reality</p>
              <h3 className="font-serif text-2xl md:text-3xl mb-5">Gentle, Restorative Rhythm</h3>
              <p className="text-fg/80 leading-relaxed md:text-lg">
                Sequential rhythm programming that meets a tired nervous system exactly where it is. Purposeful beats, offered with care, that ease tension, steady emotion, and make room to breathe again — for those navigating mental-health challenges and different abilities. Every beat with intention, every session a place to feel safe.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
